import React, { useEffect, useState } from 'react';
import { trackAndNavigate } from '../utils/pixel';
import { useTrackSection } from '../utils/useTrackSection';
const comparisonRows = [{
  without: 'Horas buscando planes en internet',
  with: 'Todo listo para entregar en consulta'
}, {
  without: 'Planes sin estructura ni criterio clínico',
  with: '30 planes organizados por objetivo'
}, {
  without: 'Pacientes sin saber qué hacer en casa',
  with: 'Material educativo listo para cada paciente'
}, {
  without: 'Sesiones sin material visual de apoyo',
  with: 'Láminas y planillas listas para usar'
}, {
  without: 'Sin sistema de seguimiento clínico',
  with: '6 planillas clínicas editables y listas'
}];
const TIMER_KEY = 'megapack_nutricion_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  return {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor(diff % (1000 * 60 * 60) / (1000 * 60)),
    seconds: Math.floor(diff % (1000 * 60) / 1000)
  };
}
export function DarkCTA() {
  useTrackSection('dark-cta', 'Final CTA Section');
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft(endTime)), 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  const offers = [{
    emoji: '👶',
    name: 'MEGAPACK BASE',
    desc: '6 tomos + 6 bonos · 0 a 36 meses completo',
    before: '$58.990 ARS',
    price: '$22.950',
    label: '→ QUIERO EL BASE',
    href: 'https://www.bibliotecaprofesional.com/cart/48299489689770:1',
    eventName: 'Megapack Base',
    value: 22950,
    highlight: false
  }, {
    emoji: '📋',
    name: 'MEGAPACK GESTIÓN COMPLETA',
    desc: 'Todo el Base + 6 Planillas Clínicas listas para tu consultorio.',
    before: '$79.990 ARS',
    price: '$29.950',
    label: '→ QUIERO GESTIÓN COMPLETA',
    href: 'https://www.bibliotecaprofesional.com/cart/48295641645226:1',
    eventName: 'Megapack Gestión Completa',
    value: 29950,
    highlight: false
  }, {
    emoji: '🏆',
    name: 'MEGAPACK CONSULTORIO PROFESIONAL',
    desc: 'Todo el Gestión Completa + Gabinete Visual + Método Integral™.',
    before: '$102.990 ARS',
    price: '$34.950',
    label: '→ QUIERO CONSULTORIO PRO',
    href: 'https://www.bibliotecaprofesional.com/cart/48388702732458:1',
    eventName: 'Megapack Consultorio Profesional',
    value: 34950,
    highlight: true
  }];
  return <section id="dark-cta" className="w-full px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-gray-900 text-base leading-6" style={{
    background: 'linear-gradient(180deg, rgb(220,252,231) 0%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-111">
      <div className="mx-auto max-w-4xl text-center" data-id="element-112">
        {/* Brand */}
        <div className="mb-8 sm:text-3xl font-black tracking-[3px] text-green-700 text-[18px]" data-id="element-113">
          🥗 MEGAPACK NUTRICIÓN RESUELTA™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold text-gray-900 m-0 mb-3" data-id="element-114">
          La próxima consulta podés volver a improvisar.
        </h2>
        <p className="text-xl sm:text-3xl font-black m-0 mb-10" style={{
        color: '#15803d'
      }} data-id="element-115">
          O podés entrar el lunes con todo resuelto desde hoy.
        </p>

        {/* Comparison Table */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl border border-gray-200 text-left bg-white" data-id="element-116">
          <div className="text-center font-bold text-gray-900 border-b border-gray-200 px-4 py-3 bg-gray-50" data-id="element-117">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          <div className="grid grid-cols-2 border-b border-gray-200 bg-gray-50" data-id="element-118">
            <div className="text-center font-bold text-gray-500 px-4 py-2 text-sm" data-id="element-119">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold border-l border-gray-200 px-4 py-2 text-sm" style={{
            color: '#15803d'
          }} data-id="element-120">
              CON MEGAPACK
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-121">
              <div className="px-4 py-2.5 text-xs sm:text-sm text-gray-500" data-id="element-122">
                ✗ {row.without}
              </div>
              <div className="px-4 py-2.5 text-xs sm:text-sm font-bold text-gray-900 border-l border-gray-100" style={{
            backgroundColor: 'rgba(21,128,61,0.05)'
          }} data-id="element-123">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-124">
          <p className="font-bold text-gray-900 m-0 mb-4" data-id="element-125">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="inline-flex items-center justify-center gap-2 sm:gap-3 rounded-2xl bg-white border border-gray-100 shadow-sm px-5 py-4 mx-auto" data-id="element-126">
            {[{
            value: pad(timeLeft.hours),
            label: 'hs'
          }, {
            value: ':',
            label: null
          }, {
            value: pad(timeLeft.minutes),
            label: 'min'
          }, {
            value: ':',
            label: null
          }, {
            value: pad(timeLeft.seconds),
            label: 'seg'
          }].map((item, i) => item.label === null ? <span key={i} className="-mt-5 text-5xl sm:text-7xl font-black leading-none" style={{
            color: 'rgb(255,68,68)'
          }} data-id="element-127">
                  :
                </span> : <div key={i} className="flex flex-col items-center min-w-[56px] sm:min-w-[80px]" data-id="element-128">
                  <span className="text-5xl sm:text-7xl font-black tabular-nums leading-none" style={{
              color: 'rgb(255,68,68)'
            }} data-id="element-129">
                    {item.value}
                  </span>
                  <span className="mt-1.5 text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-130">
                    {item.label}
                  </span>
                </div>)}
          </div>
        </div>

        <p className="text-sm text-gray-600 m-0 mb-10" data-id="element-131">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-132">$15.000 ARS</span> y no
          vuelve.
        </p>

        {/* Pricing Cards */}
        <div className="mx-auto max-w-3xl mb-10 flex flex-col gap-3" data-id="element-133">
          {offers.map(offer => <div key={offer.name} className="flex flex-col sm:flex-row items-center justify-between gap-4 rounded-2xl px-5 py-5" style={{
          border: offer.highlight ? '2px solid #15803d' : '1px solid #e5e7eb',
          backgroundColor: offer.highlight ? 'rgb(240,253,244)' : 'rgb(255,255,255)',
          boxShadow: offer.highlight ? 'rgba(21,128,61,0.12) 0px 0px 24px 0px' : 'none'
        }} data-id="element-134">
              {/* Left: info */}
              <div className="flex flex-1 items-center gap-3 text-left w-full sm:w-auto" data-id="element-135">
                <span className="text-2xl shrink-0" data-id="element-136">{offer.emoji}</span>
                <div className="min-w-0" data-id="element-137">
                  <p className="text-sm font-black m-0 leading-tight" style={{
                color: offer.highlight ? '#15803d' : '#111827'
              }} data-id="element-138">
                    {offer.name}
                  </p>
                  <p className="text-xs text-gray-500 m-0 mt-0.5 leading-snug" data-id="element-139">
                    {offer.desc}
                  </p>
                </div>
              </div>

              {/* Right: price + button */}
              <div className="flex items-center justify-between sm:justify-end gap-4 shrink-0 w-full sm:w-auto" data-id="element-140">
                <div className="text-left sm:text-right" data-id="element-141">
                  <p className="text-xs text-gray-400 line-through m-0" data-id="element-142">
                    {offer.before}
                  </p>
                  <p className="text-base font-black m-0" style={{
                color: '#15803d'
              }} data-id="element-143">
                    {offer.price}
                  </p>
                </div>
                <a href={offer.href} onClick={e => {
              e.preventDefault();
              trackAndNavigate('InitiateCheckout', {
                content_name: offer.eventName,
                content_category: 'Nutrición Resuelta',
                value: offer.value,
                currency: 'ARS'
              }, offer.href);
            }} className="shrink-0 text-white text-xs font-black rounded-xl px-5 py-3 no-underline hover:opacity-90 transition-opacity whitespace-nowrap text-center sm:min-w-[170px]" style={{
              backgroundColor: '#15803d'
            }} data-id="element-144">
                  {offer.label}
                </a>
              </div>
            </div>)}
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 text-xs sm:text-sm text-gray-600" data-id="element-145">
          <span className="inline-flex items-center bg-white border border-gray-200 rounded-full px-3 py-1.5 shadow-sm" data-id="element-146">
            🔒 Pago 100% seguro
          </span>
          <span className="inline-flex items-center bg-white border border-gray-200 rounded-full px-3 py-1.5 shadow-sm" data-id="element-147">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="inline-flex items-center bg-white border border-gray-200 rounded-full px-3 py-1.5 shadow-sm" data-id="element-148">
            🛡️ Garantía 7 días sin preguntas
          </span>
          <span className="inline-flex items-center bg-white border border-gray-200 rounded-full px-3 py-1.5 shadow-sm" data-id="element-149">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </section>;
}